import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
const fb = require('./firebaseConfig.js')
const platform = require('platform');
const globals = require('./globals.js')

Vue.use(Vuex)

fb.auth.onAuthStateChanged(authUser => {
    if (authUser) {
      console.log(`GOT AUTH USER: ${authUser.uid} - ${authUser.phoneNumber} - ${authUser.displayName})`)
      // We have an auth user, so onboard an app user
      store.commit('setAuthUser', authUser)

      // Wire up realtime user updates, making sure to retain unsubscriber method
      var unsubscribers = []
      const unsubscribeUsers = fb.usersCollection.doc(authUser.uid).onSnapshot(doc => {
        let appUser = doc.data()

        if (appUser) {
          console.log("GOT APP USER!")
          // We have an app user, so set it to the store
          appUser.uid = authUser.uid; // tack this onto app user for userId comparisons
          store.commit('setAppUser', appUser)
        }
        else {
          console.log("DON'T GOT APP USER!")
          let appUser = { 'phoneNumber': authUser.phoneNumber, 'timeZoneIdentifier': moment.tz.guess(), 'eligibleForIntroductoryOffer': true, 'badgeCount': 0 }
          store.commit('setAppUser', appUser)

          // There is no app user for this auth user, so we need to create one (including any existing event refs)
          fb.eventsCollection.where('invitationPhoneNumbers', 'array-contains', authUser.phoneNumber).get().then(querySnapshot => {
            var eventPromises = []

            querySnapshot.forEach(userEventDoc => {
              let userEvent = userEventDoc.data()
              let invitationIndex = userEvent.invitations.map(invitation => { return invitation.invitee.phoneNumber }).indexOf(authUser.phoneNumber)
              if (invitationIndex >= 0) {
                userEvent.invitations[invitationIndex].invitee.userId = authUser.uid
                userEvent.invitations[invitationIndex].invitee.isCloudMessageable = false // TODO: future support of web cloud messaging?
              }

              eventPromises.push(fb.eventsCollection.doc(userEventDoc.id).update({ invitations: userEvent.invitations }))
            })

            Promise.all(eventPromises).then(() => {
              let appUser = { 'phoneNumber': authUser.phoneNumber, 'environment': { 'platform': `Web ${platform.os.toString()}`, 'appVersion': `1.0` }, 'isSignedIn': true, 'lastSignInOutDateTime': Date(), 'timeZoneIdentifier': moment.tz.guess(), 'eligibleForIntroductoryOffer': true, 'badgeCount': userEventIds.length }
              fb.usersCollection.doc(authUser.uid).set(appUser).then(() => {
                store.commit('setAppUser', appUser)
              })
            }).catch(error => {
              console.log(`Error updating app user events.`)
            })
          })
        }
      })

      // Wire up realtime event updates, making sure to retain unsubscriber method
      const unsubscribeEvents = fb.eventsCollection.where('invitationPhoneNumbers', 'array-contains', authUser.phoneNumber).where('dateTime', '>=', moment().subtract(globals.eventRecentPeriodInHours, "hours").toDate()).orderBy('dateTime', 'asc').onSnapshot(querySnapshot => {
          let eventsArray = []
        querySnapshot.forEach(doc => {
            let event = doc.data()
            event.id = doc.id
            eventsArray.push(event)
        })

        store.commit('setEvents', eventsArray)
      })
      unsubscribers.push(unsubscribeEvents)

      unsubscribers.push(unsubscribeUsers)
      store.commit('setUnsubscribers', unsubscribers)
    }
    else {
      console.log(`NO AUTH USER!`)
      // There isn't an auth user, so do nothing as we'll auto-route to Sign In
      store.commit('setUnsubscribers', [])
    }
  })

export const store = new Vuex.Store({
    state: {
      unsubscribers: [],
      authUser: null,
      appUser: {},
      events: [],
      selectedEvent: null
    },
    getters: {
      appUser: (state) => { return state.appUser }
    },
    actions: {
      clearData({ commit, state }) {
        // First unsubscribe any data listener subscriptions
        state.unsubscribers.forEach(unsubscriber => {
          unsubscriber()
        })

        // Clear all data
        commit('setUnsubscribers', [])
        commit('setAuthUser', null)
        commit('setAppUser', {})
        commit('setEvents', [])
        commit('setSelectedEvent', null)
      },
      fetchAppUser({ commit, state }) {
        console.log(`fetchAppUser for ${state.authUser.uid}`)
        fb.usersCollection.doc(state.authUser.uid).get().then(res => {
          const appUser = res.data()
          commit('setAppUser', appUser)
        }).catch(err => {
            console.log(err)
        })
      },
      updateAppUserEnvironment({ commit, state }, data) {
        let environment = data.environment

        fb.usersCollection.doc(state.authUser.uid).update({ environment }).then(user => {
        }).catch(err => {
            console.log(err)
        })
      },
      updateAppUserSignedIn({ commit, state }, data) {
        let isSignedIn = data.isSignedIn

        fb.usersCollection.doc(state.authUser.uid).update({ isSignedIn }).then(user => {
        }).catch(err => {
            console.log(err)
        })
      },
      updateAppUserLastSignInOutDateTime({ commit, state }, data) {
        let lastSignInOutDateTime = data.lastSignInOutDateTime

        fb.usersCollection.doc(state.authUser.uid).update({ lastSignInOutDateTime }).then(user => {
        }).catch(err => {
            console.log(err)
        })
      },
      updateAppUserName({ commit, state }, data) {
        let givenName = data.givenName
        let familyName = data.familyName

        fb.usersCollection.doc(state.authUser.uid).update({ givenName, familyName }).then(user => {
          // update all events by user to reflect new given name
          fb.eventsCollection.where('creatorUserId', '==', state.authUser.uid).get().then(docs => {
            docs.forEach(doc => {
              fb.eventsCollection.doc(doc.id).update({
                userName: `${givenName} ${familyName}`
              })
            })
          })
        }).catch(err => {
            console.log(err)
        })
      },
      updateAppUserPhoneNumber({ commit, state }, data) {
        let phoneNumber = data.phoneNumber

        fb.usersCollection.doc(state.authUser.uid).update({ phoneNumber }).then(user => {
          // update all events by user to reflect new given name
          fb.eventsCollection.where('creatorUserId', '==', state.authUser.uid).get().then(docs => {
            docs.forEach(doc => {
              fb.eventsCollection.doc(doc.id).update({
                phoneNumber: phoneNumber
              })
            })
          })
        }).catch(err => {
            console.log(err)
        })
      }
    },
    mutations: {
      setUnsubscribers(state, val) {
        state.unsubscribers = val
      },
      setAuthUser(state, val) {
        state.authUser = val
      },
      setAppUser(state, val) {
          state.appUser = val
      },
      setEvents(state, val) {
        if (val) {
          state.events = val
        } else {
          state.events = []
        }
      },
      setSelectedEvent(state, val) {
        state.selectedEvent = val
      }
    }
})



// WEBPACK FOOTER //
// ./src/store.js